// ============================================================
//	らんま1/2 × studio CLIP
// ============================================================

// ------------------------------------------------
//	スクロールアニメーション（.anim → .active）
// ------------------------------------------------
const scrollAnim = () => {
	const items = document.querySelectorAll('.anim');
	if (!items.length) return;

	const check = () => {
		const th = window.innerHeight * 0.85;
		// ページ最下部の要素は、スクロールしきっても画面の下15%に留まって発火しない。
		// 最下端まで来たら残りを全部出す
		const atBottom =
			window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;

		items.forEach((el) => {
			if (el.classList.contains('active')) return;
			const r = el.getBoundingClientRect();
			if (atBottom || (r.top < th && r.bottom > 0)) el.classList.add('active');
		});
	};

	check();
	window.addEventListener('load', check, { once: true });
	window.addEventListener('scroll', check, { passive: true });
	window.addEventListener('resize', check);
};

// ------------------------------------------------
//	発売までのカウントダウン（KV「あと ７ 日」）
//	発売日 2026-09-18 10:00（and ST 実店舗）までの残り日数。※2026-09-07 古澤さんお戻し①で 9/17→9/18 へ変更
//	当日以降は 0 になる。日数の出し分け方針が決まったら RELEASE_AT だけ差し替える。
// ------------------------------------------------
const RELEASE_AT = new Date('2026-09-18T10:00:00+09:00');

const countdown = () => {
	const el = document.querySelector('.rm__cd-num');
	if (!el) return;

	const diff = RELEASE_AT.getTime() - Date.now();
	const days = Math.max(0, Math.ceil(diff / 86400000));
	el.textContent = String(days);
};

// ------------------------------------------------
//	オープニング（loading → KV）
//	固定で抜ける。`?skip` でローディングとKVの順送りを丸ごと飛ばす
// ------------------------------------------------
const OPENING_MS = 7200; // ローディングの3つのオブジェクトが3周する時間（2.4s × 3）

const isSkip = () => new URLSearchParams(location.search).has('skip');

const opening = () => {
	const op = document.getElementById('rmop');
	const rm = document.querySelector('.rm');
	if (!rm) return;

	// KVの順送りが始まってからスクロール出現を有効にする（KVより先に本文が出ないように）
	const start = () => {
		rm.classList.add('is-op');
		scrollAnim();
	};

	// ?skip はローディング画面だけ飛ばす。KVの順送りは通常どおり走らせる
	if (isSkip()) {
		if (op) op.remove();
		start();
		return;
	}

	if (!op) {
		start();
		return;
	}

	window.setTimeout(() => {
		op.classList.add('is-out');
		start();
		op.addEventListener('animationend', () => op.remove(), { once: true });
	}, OPENING_MS);
};

window.addEventListener('DOMContentLoaded', () => {
	countdown();
	opening(); // scrollAnim は .is-op と同時に開始する
});
